var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8571 16.7143C21.8571 17.424 21.2811 18 20.5714 18H1.28571C0.576 18 0 17.424 0 16.7143V1.28571C0 0.576 0.576 0 1.28571 0H20.5714C21.2811 0 21.8571 0.576 21.8571 1.28571V16.7143Z",
    fill: "#D79E84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 0H1.28571C0.576 0 0 0.576 0 1.28571V16.7143C0 16.9644 0.0745715 17.1951 0.197357 17.3925L21.6238 0.550928C21.3917 0.218571 21.0079 0 20.5714 0Z",
    fill: "#BF6952"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 11.5714V3.2143C19.2857 2.85944 18.9983 2.57144 18.6428 2.57144H3.21427C2.85941 2.57144 2.57141 2.85944 2.57141 3.2143V11.5714H19.2857Z",
    fill: "#8CCAF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21427 15.4286H11.5714V10.9286H2.57141V14.7857C2.57141 15.1412 2.85941 15.4286 3.21427 15.4286Z",
    fill: "#5DADEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5714 10.9286V15.4286H18.6428C18.9983 15.4286 19.2857 15.1412 19.2857 14.7857V10.9286H11.5714Z",
    fill: "#292F33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2143 9.64285C11.8202 9.64285 11.6666 10.3674 11.3111 10.9286C11.0867 11.2821 10.7826 11.5714 10.2857 11.5714C8.99998 11.5714 8.99998 13.5 8.35712 13.5C7.54969 13.5 6.74227 14.5144 6.25305 15.4286H11.5714C12.1365 14.2984 12.7035 13.1696 14.1428 12.9131C14.3402 12.8777 14.553 12.8571 14.7857 12.8571C16.7143 12.8571 16.7824 11.8588 17.3571 11.5714C18.2301 11.1349 18.8042 11.2905 19.2857 11.4358V9.64285H12.2143Z",
    fill: "#67757F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 4.5L12.8572 7.07143V9.64286H18V7.07143L15.4286 4.5Z",
    fill: "#E75A70"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.7143C17.8354 7.7143 17.6708 7.6513 17.5455 7.52594L15.4286 5.40901L13.3116 7.52594C13.0603 7.7773 12.654 7.7773 12.4026 7.52594C12.1513 7.27458 12.1513 6.8683 12.4026 6.61694L14.9741 4.04551C15.2254 3.79416 15.6317 3.79416 15.8831 4.04551L18.4545 6.61694C18.7058 6.8683 18.7058 7.27458 18.4545 7.52594C18.3291 7.6513 18.1646 7.7143 18 7.7143Z",
    fill: "#292F33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1428 7.71429H15.4285V9.64287H14.1428V7.71429Z",
    fill: "#BB1A34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4265 6.50893C10.4265 5.84293 9.88716 5.30358 9.22116 5.30358C9.17037 5.30358 9.12152 5.31258 9.07202 5.31836C9.09002 5.23543 9.1003 5.15058 9.1003 5.0625C9.1003 4.3965 8.56095 3.85715 7.89495 3.85715C7.46552 3.85715 7.09073 4.08343 6.8773 4.42158C6.74359 4.37015 6.60023 4.33929 6.44852 4.33929C5.83652 4.33929 5.33637 4.79765 5.25859 5.38843C5.12295 5.33508 4.97637 5.30358 4.82145 5.30358C4.15545 5.30358 3.61609 5.84293 3.61609 6.50893C3.61609 7.17493 4.15545 7.71429 4.82145 7.71429C4.8478 7.71429 4.87287 7.70786 4.89923 7.70658L4.9018 7.71429H9.24109V7.71236C9.89745 7.70143 10.4265 7.16786 10.4265 6.50893Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.5044629abb0f709da01089656a32a7ad.svg";
export { ForwardRef as ReactComponent };